export const getCareStaticData = [
  {
    title: 'Book an appointment',
    desc: 'Book an appointment',
    keywords: ['book', 'schedule', 'appointment', 'visit'],
    to: '/u/get-care-now/booking/patient-select'
  },
  {
    title: 'Connect Care',
    desc: '24/7 video visit for low-level urgent conditions',
    keywords: ['online', 'video', 'virtual', 'visit'],
    to: '/u/get-care-now/connect-care'
  },
  {
    title: 'Nearest InstaCare',
    desc: 'Urgent care for non life-threatening conditions',
    keywords: ['check-up', 'sick', 'hospital', 'visit'],
    to: '/u/get-care-now/live-care/instacares'
  },
  {
    title: 'Nearest Kids Care',
    desc: 'Pediatric urgent-care for non life-threatening needs',
    keywords: ['children', 'pediatric', 'kid', 'hospital'],
    to: '/u/get-care-now/live-care/kidscares'
  },
  {
    title: 'Nearest Emergency Room',
    desc: 'Fast, immediate care for severe symptoms',
    keywords: ['urgent', 'injury', 'sick', 'help', 'hospital', 'emergency'],
    to: '/u/get-care-now/live-care/emergencyRooms'
  },
  {
    title: 'Behavioral Health Services',
    desc: 'Guidance, tools, and referrals for mental well-being',
    keywords: ['mental health', 'behavioral', 'help', 'therapy'],
    to: '/u/get-care-now/care/emotionalSupport'
  },
  {
    title: 'Check Symptoms',
    desc: 'Care Guidance based on symptoms',
    keywords: ['symptom', 'check', 'sick'],
    to: '/u/assess-my-symptoms/terms'
  }
];

export const getCareLinks = () => {
  return getCareStaticData.map(item => {
    return {
      title: item.title,
      category: 'getCare',
      icon: 'WebGetCareNow',
      keywords: ['get care', item.desc, item.keywords],
      data: item,
      navWebPath: item.to
    };
  });
};
